import { Message } from "./Message";
import { Sender } from "./Sender";

export class MessagePackage
{
    public Message: Message = new Message();
    public Sender: Sender = new Sender();
}
